<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import { ADDON_GROUP, planTypes } from '@/common/constants';
import addonCustomSelect from '@/plans/mx/addonCustomSelect';
import { get, orderBy } from 'lodash';
import { plansof } from '@/utils/chain';
import { PBX_SUB_TYPES } from '@/common/service/computers/plans/pbx';
import { addDefaultPbxBasePlanToShoppingCartByQuery } from '@/flows/BUY_NOW';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ZoomPhoneAddon',
  mixins: [base, addonCustomSelect],
  group() {
    return [ADDON_GROUP.WIN_BACK];
  },
  data() {
    return {
      title: this.$t('billing.pbx.title'),
      logo: require('@/assets/plans/logo_pbx.svg'),
      planType: planTypes.ZOOM_PHONE,
      description: this.$t('billing.pbx.desc'),
    };
  },
  computed: {
    ...mapGetters(['selectedPbxBasePlan']),
    lowestPlan() {
      const { planCode } = this.pastPlans?.find(p => planTypes[p.semanticType] === planTypes.ZOOM_PHONE);
      if (planCode) {
        const { region } = plansof(this.planMapFlat).code(planCode).get(0) || {};
        const list = plansof(this.planMapFlat).type(planTypes.ZOOM_PHONE).sub_type(PBX_SUB_TYPES.METERED, PBX_SUB_TYPES.UNLIMITED).monthly().region(region).get();
        const listSort = orderBy(
          list,
          ['amount'],
          'asc',
        );
        return get(listSort, [0], {});
      }
      return {};
    },
  },
  methods: {
    ...mapMutations(['setPbxBasePlanCode','setPlanMapFlat']),
    addOn(evt) {
      // addPlanFromEnterKey For A11Y requirement
      // target is BUTTON comes from keyboard enter, will auto focaus on the first option in config card
      // target is SPAN comes from click
      const addPlanFromEnterKey = get(evt.target, 'tagName', '') == 'BUTTON';
      if (addPlanFromEnterKey) {
        document.addPlanFromEnterKey = true;
      }
      this.updateSelectPlan({
        ...this.formPlan,
        cartInfo: {
          selected_number: this.form.selectedNumber,
        },
      });
      this.$emit('add', this.$options?.key);
      //add phone usage plan
      addDefaultPbxBasePlanToShoppingCartByQuery(this.planMapFlat);
      this.setPlanMapFlat([...this.planMapFlat]);
      if (this.selectedPbxBasePlan) {
        this.setPbxBasePlanCode(this.selectedPbxBasePlan.plan_code);
        this.savePersist()
      }
      this.$tracking.addOnBuyInteraction('add-ons', `${this.title?.toLowerCase()} - add`);
      this.$nextTick(this.focusToConfig);
    },
  }
};
</script>
